const ACTION_PREFIX = `@komigen/mobile-frontend/casino-shared`;
export const UPDATE_LIKES_INFO = `${ACTION_PREFIX}/UPDATE_LIKES_INFO`;
export const SET_LOVED_AND_RECENT = `${ACTION_PREFIX}/SET_LOVED_AND_RECENT`;
export const ADD_LOCAL_RECENTLY_PLAYED = `${ACTION_PREFIX}/ADD_LOCAL_RECENTLY_PLAYED`;
export const SET_SWITCH_TO_REAL = `${ACTION_PREFIX}/SET_SWITCH_TO_REAL`;
export const JACKPOT_SOCKET_ON_CONNECTION_OPEN = `${ACTION_PREFIX}/JACKPOT_SOCKET_ON_CONNECTION_OPEN`;
export const JACKPOT_SOCKET_SET_RETRY_TIMEOUT = `${ACTION_PREFIX}/JACKPOT_SOCKET_SET_RETRY_TIMEOUT`;
export const JACKPOT_SOCKET_ON_MESSAGE = `${ACTION_PREFIX}/JACKPOT_SOCKET_ON_MESSAGE`;
export const JACKPOT_SOCKET_CLOSE_CONNECTION = `${ACTION_PREFIX}/JACKPOT_SOCKET_CLOSE_CONNECTION`;
export const SET_ACTIVE_FILTERS = `${ACTION_PREFIX}/SET_ACTIVE_FILTERS`;
export const RESET_ACTIVE_FILTERS = `${ACTION_PREFIX}/RESET_ACTIVE_FILTERS`;
export const SET_ACTIVE_SORTING = `${ACTION_PREFIX}/SET_ACTIVE_SORTING`;
export const RESET_ACTIVE_SORTING = `${ACTION_PREFIX}/RESET_ACTIVE_SORTING`;
export const SET_JACKPOT_DATA = `${ACTION_PREFIX}/SET_JACKPOT_DATA`;
export const SET_IS_INSUFFICIENT_CASINO_BALANCE_MODAL_SHOWN = `${ACTION_PREFIX}/SET_IS_INSUFFICIENT_CASINO_BALANCE_MODAL_SHOWN`;
export const SET_IS_ZERO_CASINO_BALANCE_MODAL_SHOWN = `${ACTION_PREFIX}/SET_IS_ZERO_CASINO_BALANCE_MODAL_SHOWN`;
export const SET_IS_BALANCE_LIMIT_EXCEEDED_MODAL_SHOWN = `${ACTION_PREFIX}/SET_IS_BALANCE_LIMIT_EXCEEDED_MODAL_SHOWN`;
